// Bentuk data Rute Kirim (GET /api/routes, /api/routes/:id — server/routes/ops.js ROUTE_SQL & routeDetail).

export interface RouteRow {
  id: number;
  no: string;
  status: string;
  driver_id: number;
  driver_name: string;
  driver_phone: string | null;
  ship_date: string;
  area: string;
  created_by_name: string | null;
  created_at: string;
  nota_count: number;
  total: number;
  siap: number;
  jalan: number;
  selesai: number;
}

export interface LoadingProduct {
  key: string;
  product_id: number;
  code: string;
  name: string;
  /** Label singkat & kelompok kolom Rekapitulasi (Produk & Harga). */
  label?: string;
  group?: string;
  unit: string;
  factor: number;
  total: number;
  stock: number;
  base_unit: string;
  short: boolean;
}

export interface Loading {
  products: LoadingProduct[];
  stores: { store_id: number; store_name: string; area: string; seq: number; qty: Record<string, number>; total: number }[];
  grand: number;
}

export interface BillItem {
  id: number;
  no: string;
  status: string;
  pay_method: string;
  due_date: string | null;
  total: number;
  paid: number;
  store_name: string;
  address: string;
  area: string;
  sales_name: string;
  sales_initials?: string;
  qty: number;
  /** Qty kolom S (Selai) & O (Other) sesuai divisi produk di Data Master. */
  qty_s: number;
  qty_o: number;
  /** Titipan: pembayaran sah sebelum driver berangkat (TTPN). */
  titipan: number;
  titipan_date: string | null;
  cash_driver: number;
  sts: string;
  retur: boolean;
  delivered: boolean;
  tagihan: number;
  sisa: number;
}

export interface Billing {
  items: BillItem[];
  totals: { nota: number; titipan: number; tagihan: number; realisasi: number; sisa: number; qty_s: number; qty_o: number };
  deposit: { no: string; expected: number; received: number; diff: number; note: string } | null;
  cash_unsettled: number;
}

export interface RouteNota {
  id: number;
  no: string;
  status: string;
  store_name: string;
  pay_method: string;
  total: number;
}

export interface RouteDetail {
  item: RouteRow;
  notas: RouteNota[];
  loading: Loading;
  billing: Billing;
}

/** Status rute → [label, kelas pill] (v1 routeStat). */
export const routeStat = (r: RouteRow): [string, string] =>
  r.status === 'selesai'
    ? ['Selesai', 't-ok']
    : r.nota_count && r.selesai === r.nota_count
      ? ['Perlu ditutup', 't-accent']
      : r.jalan
        ? ['Di jalan', 't-accent']
        : r.nota_count && r.siap === r.nota_count
          ? ['Siap muat', 't-warn']
          : ['Sebagian', 't-warn'];
